export default {
    til: '洋碩美語',
    login: {
        inp: ['請輸入', 'Enter Your Email', '請輸入密碼']
    },
    logout: {
        txt: '登出',
        dialog: ['確定登出?', '登出', '取消']
    },
    ui: {
        next: '下一個',
        back: '上一個'
    },
    menu: {
        toDay: '今日單字',
        toWord: '每日單字',
        practice: '精熟練習',
        classTest: 'Unit Test',
        myClass: '我的課程',
        myNote: '我的筆記',
        myTest: '我的測驗',
        myDoc: '學習紀錄'
    },
    StudyRecordStats: [['已練習', '次'], '點選開始練習', '點選開始測驗','已通過測驗'],
    foot: [
        '洋碩美語為回饋社會，凡清寒(領有縣市政府低收入戶證明書)、身障(中度以上)學子，一律五折優待，我們真心希望清寒學子也能享有同齡學子的夢想。',
        'Copyright © TKB臺灣知識庫 All Rights Reserved.'
    ],
    nodata: '沒有資料',
    noQuestionModel: '目前沒有題目',
    noExercise: ['您的練習次數未滿2次，請完成練習！', '繼續練習'],
    nextTest: '繼續下個精熟練習',
    report: '觀看紀錄圖表'
}



// WEBPACK FOOTER //
// ./src/lang/zh_TW.js